module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "chapter-one"
    }
  }, [_c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "appetizers-all-the-young-dudes-cooking-the-foods"
    }
  }, [_c('div', {
    staticClass: "section level3",
    attrs: {
      "id": "roasted-red-hot-chili-pepper-soup"
    }
  }, [_c('h3', [_vm._v("Roasted Red Hot Chili Pepper Soup")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("A great hearty-heavy—metal-rock soup for the cold days or the days where you just need to fire up the music, when you just feel like something different—something with a spicy taste for the palette. If that is not "), _c('strong', [_c('em', [_vm._v("One Hot Minute")])]), _vm._v("—nothing is.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "font-weight": "bold"
    }
  }, [_vm._v("https://www.youtube.com/watch?v=T6Ii7D4rYrg")]), _vm._v(" "), _c('div', {
    staticClass: "figure",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "4.85517in",
      "height": "3.25in"
    },
    attrs: {
      "alt": "",
      "src": "media/file1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("A bowl of soup with a spoon Description automatically generated")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('h4', [_vm._v("Ingredients")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("1/2 pound of leftover meat cut into chunks, or stew meat")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("2 cups of chicken broth")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("2 large red onions")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("2 tbsp. of oil")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("2 large tomatoes or 1 can of tomato sauce (12 oz.)")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("Salt, pepper, to taste")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("3 large whole red peppers cut in half")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("1/2 teaspoon of red chili peppers or two tablespoons of hot sauce for that ‘Hotter than Hell’ taste.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("2 cups of water")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("1 can of cream and mushroom soup.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("Add 1 teaspoon of curry powder for taste")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_c('strong', [_vm._v("Instructions")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_c('strong', [_vm._v("1. ")]), _vm._v("Preheat oven to 375F (190C). Place whole red peppers on a baking sheet and roast it, uncovered, for about 18 minutes on high broil. Turn peppers and continue roasting about 18 more minutes, until their skin is blistered. Remove them from baking sheet and place them in ice cold water for 5 to 10 minutes. Once cooled, peel off their skins. Slice them in half and remove out the seeds. Cut into large chunks and set them aside, or for a less chunky soup, put them in a blender and pulse blend it. Refrigerate if making ahead.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_c('strong', [_vm._v("2. ")]), _vm._v("In a large saucepan, heat oil over medium heat. Add garlic and onions. Sauté until onions are very soft, for about 6 minutes. Stir in roasted peppers and continue cooking until peppers are very soft. Then, whirl in a blender or a food processor, using pulse, until smooth. Return puréed mixture to saucepan and add chicken broth. Cover and cook over medium heat, stirring occasionally, until soup is warm, which will usually take 8 to 10 minutes. Spoon into soup bowls and sprinkle with black pepper. Covered and refrigerated, soup will keep well for at least 2 days and can be frozen.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_c('strong', [_vm._v("3. ")]), _vm._v("This soup, with its smoky, slightly sweet flavour from the roasting of the peppers, is a rock ’em-dead beginning for any meal. Add hot chili peppers or your favourite hot sauce for an out-of-this-world flavour.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bdc24252","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Section0002.vue
// module id = 84
// module chunks = 0